module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/common/calendar-0d21d5ade3fbd982006c13164a14987b.svg";